module.exports = __webpack_public_path__ + "static/media/about-us.2e4a9e6c.png";